import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/login";
import Home from "./pages/home";
import Confirmation from "./pages/confiramtion";
import Report from "./pages/report";
import ResidentManagement from "./pages/residentmanagement";
import Admin from "./pages/admin";
import StaffManagement from "./pages/staffmanagement";
import AdminReports from "./pages/adminreport";
import PropertyManagement from "./pages/propertymanagement";
import Executive from "./pages/executive";
import ExecutiveReport from "./pages/executivereport";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/admin-login" element={<Login />} />
          <Route path="/home" element={<Home />} />
          <Route path="/confirmation" element={<Confirmation />} />
          {/* <Route path="/report" element={<ProtectedRoute><Report /></ProtectedRoute>} /> */}
          {/* <Route path="/resident" element={<ProtectedRoute><ResidentManagement /></ProtectedRoute>} /> */}
          <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          {/* <Route path="/staff" element={<ProtectedRoute><StaffManagement /></ProtectedRoute>} /> */}
          <Route path="/adminreport" element={<ProtectedRoute><AdminReports /></ProtectedRoute>} />
          {/* <Route path="/property" element={<ProtectedRoute><PropertyManagement /></ProtectedRoute>} /> */}
          {/* <Route path="/executive" element={<ProtectedRoute><Executive /></ProtectedRoute>} /> */}
          {/* <Route path="/executivereport" element={<ProtectedRoute><ExecutiveReport /></ProtectedRoute>} /> */}

          {/* Catch-all route for undefined paths */}
          <Route path="*" element={<div style={{ textAlign: 'center', marginTop: '50px' }}><h2>Error: Route not exist</h2></div>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
